<div class="mbs-input mbs-timepicker_input">
  @if (label && id) {
    <mbs-input-label
      [boldLabel]="boldLabel"
      [disabled]="disabledState"
      [id]="id"
      [info]="info"
      [infoPlacement]="infoPlacement"
      [infoTriggers]="infoTriggers"
      [infoContainer]="infoContainer"
      [label]="label"
      [labelClasses]="labelClasses"
      [labelContentClasses]="labelContentClasses"
      [labelSize]="labelSize"
      [required]="hasRequiredValidator && showRequiredMark">
      <ng-content
        ngProjectAs="[prependLabel]"
        select="[prependLabel]" />
      <ng-content
        ngProjectAs="[appendLabel]"
        select="[appendLabel]" />
    </mbs-input-label>
  }

  <div class="input-group mbs-timepicker_input-group">
    @if (prependButtons || prepend) {
      <mbs-input-pre-append
        [data]="prependButtons"
        [dataTemplate]="prepend"
        [disabled]="disabledState"
        [position]="'prepend'"
        [size]="$any(size)"
        (buttonClick)="buttonClickPrepend.emit($event)"
        (keyupEnter)="dropdown.close()" />
    }

    <div
      #mbsTimepicker="ngbDropdown"
      ngbDropdown
      class="input-group_control flex-grow-1 mbs-timepicker_input-group_control"
      [autoClose]="'outside'"
      [container]="'body'"
      [dropdownClass]="dropdownClass"
      [ngClass]="[size ? 'input-group_control-' + size : '']"
      [placement]="placement">
      <input
        ngbDropdownToggle
        class="form-control mbs-timepicker_form-control"
        triggers="manual"
        [attr.aria-describedby]="id"
        [attr.aria-labelledby]="label"
        [autocomplete]="autocomplete"
        [disabled]="disabledState"
        [id]="id"
        [imask]="imaskOptions"
        [name]="name"
        [ngClass]="bindClasses"
        [placeholder]="placeholder"
        [readonly]="readonlyState"
        [tabindex]="tabindex"
        [unmask]="unmask"
        [value]="value"
        (blur)="timePickerBlurHandler($any($event))"
        (change)="handleChange($any($event))"
        (focus)="handleFocus($event)"
        (input)="handleChange($any($event))" />

      <div
        ngbDropdownMenu
        class="mbs-timepicker_dropdown -arrow">
        <ngb-timepicker
          class="mbs-timepicker_timepicker"
          [hourStep]="hourStep"
          [meridian]="meridian"
          [minuteStep]="minuteStep"
          [seconds]="showSeconds"
          [secondStep]="secondStep"
          [spinners]="spinners"
          [(ngModel)]="value" />
      </div>

      @if (loading) {
        <div class="loader-container">
          <span class="loader"></span>
        </div>
      }
    </div>

    <mbs-input-pre-append
      [data]="[
        {
          icon: 'ico ico-ClockO',
          type: 'secondary'
        }
      ]"
      [disabled]="disabledState"
      [position]="'append'"
      [size]="$any(size)"
      (buttonClick)="mbsTimepicker.open()"
      (keyupEnter)="mbsTimepicker.close()" />

    @if (appendButtons || append) {
      <mbs-input-pre-append
        [data]="appendButtons"
        [dataTemplate]="append"
        [disabled]="disabledState"
        [position]="'append'"
        [size]="$any(size)"
        (buttonClick)="buttonClickAppend.emit($event)"
        (keyupEnter)="dropdown.close()" />
    }
  </div>

  @if (isShowErrors) {
    <mbs-input-errors [errors]="errors" />
  }
</div>
